import { Stack } from '@mui/material'

import { useCanAddNewOrder, useIsSimulation, useOrdersLimit } from '@/hooks'

import { useTexts } from '../useTexts'

export function useDuplicateButtonData() {
  const canAddNewOrder = useCanAddNewOrder()
  const isSimulation = useIsSimulation()
  const ordersLimit = useOrdersLimit()
  const texts = useTexts()

  const duplicateDisabled = !canAddNewOrder

  const duplicateTooltip = duplicateDisabled ? (
    <Stack spacing={1}>
      <span>{texts.duplicateDisabledTooltipTitle(isSimulation)}</span>
      <span>{texts.duplicateDisabledTooltipSubtitle(isSimulation, ordersLimit)}</span>
    </Stack>
  ) : (
    texts.duplicate
  )

  return {
    duplicateTooltip,
    duplicateDisabled,
  }
}
